import _ from "lodash"

export default{
    data(){
        return{
            allItems: [],
            items: [],
            pageNow: +this.$route.query.page || 1,
            pageCount: 0,
            itemOnPage: 5,
        }
    },
    computed: {
        itemCoutner(){
            return this.itemOnPage * (this.pageNow - 1) + 1;
        }
    },
    methods: {
        changePage(page){
            this.$router.push(`${this.$route.path}?page=${page}`)
            this.items = this.allItems[page - 1] || this.allItems[0];
        },
        paginationInit(allItems){
            this.allItems = _.chunk(allItems, this.itemOnPage);
            this.items = this.allItems[this.pageNow - 1] || this.allItems[0];
            this.pageCount = this.allItems.length;
        }
    },
}